<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import EmployeeAPI from "../../../services/employee/employeeAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyAPI from "../../../services/company/companyAPI";
import CompanySSOAPI from "../../../services/sso/company/companySSO.API";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import BranchOfficeAPI from "../../../services/branch_offices/branch_officesAPI";
import ARLAPI from "../../../services/arl/arlAPI";
import EPSAPI from "../../../services/eps/epsAPI";
import AFPAPI from "../../../services/afp/afpAPI";
import IDTypeAPI from "../../../services/employee/idTypeAPI";
import Swal from "sweetalert2";
import { number } from "@coders-tm/vue-number-format";
import municipalityAPI from "@/services/employee/municipalityAPI";
import departmentAPI from "@/services/employee/departmentAPI";
import { required, email, maxLength } from "vuelidate/lib/validators";
import { sendNotification } from "@/utils/helpers/notification";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Registro de colaborador",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    number,
  },
  data() {
    return {
      title: "Gestión empresa",
      items: [
        {
          text: "Listado de empresas",
          href: "/forms/listado-empresa",
        },
        {
          text: "Gestión empresa",
          href: `/forms/editar-empresa/${this.$store.getters["company/getCompany"].uuid}`
        },
        {
          text: "Editar empleado",
          active: true,
        },
      ],

      checked: true,
      checked2: false,
      status: "accepted",
      status2: "not_accepted",
      selected: "A",
      file: null,
      municipality: null,
      department: null,

      number: {
        decimal: ",",
        separator: ".",
        precision: 2,
        masked: false,
      },

      showNotification: false,

      branchOffices: [],
      company_name: null,

      companyResponse: null,

      submitted: false, // validation

      employeeData: {
        full_name: null,
        identification_number: null,
        gender: null,
        scholarship: null,
        marital_status: null,
        birthday: null,
        job_method: null,
        contract_start_date: null,
        contract_end_date: null,
        contribution_base_income: 0,
        phone_1: null,
        phone_2: null,
        neighborhood: null,
        address: null,
        neighborhood_type: null,
        personal_email: null,
        corporate_email: null,
        arl_certificate: null,
        risk_class: null,
        is_active: 1,
        op_admin: "operative",
        identification_type_id: 1,
        branch_office_id: 1,
        contract_type_id: null,
        municipality_id: null,
        companies_id: null,
        afp_id: 1,
        eps_id: 1,
        rol_id: 5,
        implementation_status: 0,
        position: null,
        person_with_life: null,
        stratum_socioeconomic: null,
        colorcast: null,
        workshift: null,
        blood_group: null,
        emergency_contact_name: null,
        emergency_contact_relationship: null,
        emergency_contact_phone: null,
        emergency_contact_municipality_id: null,
      },

      allMunicipalities: [],
      bloodGroups: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
      emergencyMunicipalitySearch: "",
      emergencyMunicipalityOpen: false,

      arl: null,
      eps: [],
      afp: [],
      idTypes: [],

      department: null,
      department_id: 1,
      municipality: null,

      loading1: true,
      dato: "2022-01-01",
      anos: null,
      numero: null,

      companyData: this.$store.getters["company/getCompany"] || null,
      company: this.$store.getters["company/getCompany"] || null,
      company_id: this.$store.getters["company/getCompany"].id,
      nit: this.$store.getters["company/getCompany"].nit || null,
      lastId: 1
    };
  },
  validations: {
    employeeData: {
      full_name: {
        required,
        maxLength: maxLength(60),
      },
      identification_number: {
        required,
      },
      gender: {
        required,
      },
      colorcast: {
        required,
      },
      stratum_socioeconomic: {
        required,
      },
      person_with_life: {
        required,
      },
      workshift: {
        required,
      },
      identification_type_id: {
        required,
      },
      scholarship: {
        required,
      },
      marital_status: {
        required,
      },
      birthday: {
        required,
      },
      job_method: {
        required,
      },
      contract_start_date: {
        required,
      },
      contribution_base_income: {
        required,
      },
      phone_1: {
        required,
        maxLength: maxLength(15),
      },
      phone_2: {
      },
      neighborhood: {
        required,
        maxLength: maxLength(45),
      },
      op_admin: {
        required,
      },
      address: {
        required,
        maxLength: maxLength(45),
      },
      neighborhood_type: {
        required,
      },
      personal_email: {
        required,
        email,
        maxLength: maxLength(80),
      },
      corporate_email: {
        required,
        email,
        maxLength: maxLength(80),
      },
      arl_certificate: {
        required,
      },
      risk_class: {
        required,
      },
      is_active: {
        required,
      },
      op_admin: {
        required,
      },
      contract_type_id: {
        required,
      },
      municipality_id: {
        required,
      },
      afp_id: {
        required,
      },
      eps_id: {
        required,
      },
      position: {
        required,
        maxLength: maxLength(30),
      },
    },
  },
  computed: {
    filteredEmergencyMunicipalities() {
      const q = (this.emergencyMunicipalitySearch || "").toLowerCase().trim();
      const list = this.allMunicipalities || [];
      if (!q) return list;
      return list.filter((m) => (m.name || "").toLowerCase().includes(q));
    },
  },
  watch: {
    allMunicipalities() {
      this.syncEmergencyMunicipalityLabel();
    },
    "employeeData.emergency_contact_municipality_id"() {
      this.syncEmergencyMunicipalityLabel();
    },
  },
  methods: {

    moneda() {
      let cuenta = this.employeeData.contribution_base_income;
      this.numero = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });
    },

    CalcularEdad(birthday) {
      let actual = new Date();
      let nacimiento = new Date(birthday);
      this.anos = actual.getFullYear() - nacimiento.getFullYear();

      // Verifica si aún no ha pasado el cumpleaños este año
      if (
        actual.getMonth() < nacimiento.getMonth() ||
        (actual.getMonth() === nacimiento.getMonth() && actual.getDate() < nacimiento.getDate())
      ) {
        this.anos--;
      }
      return this.anos;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     */
    sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        company.id_diseno_sso,
        messageID,
        itemID
      );
    },

    getMunicipality() {
      municipalityAPI
        .getAllMunicipality()
        .then((response) => {
          this.municipality = response.List.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllMunicipalitiesForEmergency() {
      municipalityAPI
        .getAllUnpaginated()
        .then((response) => {
          this.allMunicipalities = response.List || [];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onEmergencyMunicipalitySearch(e) {
      this.emergencyMunicipalitySearch = e.target.value;
      this.emergencyMunicipalityOpen = true;
      if (!e.target.value) {
        this.employeeData.emergency_contact_municipality_id = null;
      }
    },

    selectEmergencyMunicipality(item) {
      this.employeeData.emergency_contact_municipality_id = item.id;
      this.emergencyMunicipalitySearch = item.name;
      this.emergencyMunicipalityOpen = false;
    },

    closeEmergencyMunicipalityDropdown() {
      setTimeout(() => {
        this.emergencyMunicipalityOpen = false;
      }, 150);
    },

    syncEmergencyMunicipalityLabel() {
      const id = this.employeeData.emergency_contact_municipality_id;
      const list = this.allMunicipalities || [];
      if (!id || list.length === 0) return;
      const m = list.find((x) => x.id === id);
      if (m && this.emergencyMunicipalitySearch !== m.name) {
        this.emergencyMunicipalitySearch = m.name;
      }
    },

    getByMunByDeparment() {
      municipalityAPI
        .getByDepartment(this.department_id)
        .then((response) => {
          this.municipality = response.List;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDepartment() {
      departmentAPI
        .getAllDepartment()
        .then((response) => {
          this.department = response.List;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeDate() {
      if (this.employeeData.is_active === 1) {
        this.employeeData.contract_end_date = null;
      }
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async getLastId() {
      try {
        const resp = await EmployeeAPI.allEmployees();
        const list = resp["employees:"] || resp.employees || [];
        if (Array.isArray(list) && list.length > 0 && list[0].id) {
          this.lastId = Number(list[0].id) + 1;
          return;
        }
        // Fallback seguro para evitar bloqueo del flujo por formato inesperado.
        this.lastId = Date.now();
      } catch (error) {
        console.log(error);
        this.lastId = Date.now();
      }
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/Registro_Empleados/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/Registro_Empleados/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.employeeData.arl_certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true;

      try {
        const companyId = Number(this.employeeData.companies_id || this.company_id);
        if (!companyId || Number.isNaN(companyId)) {
          this.loading1 = false;
          this.submitted = false;
          Swal.fire({
            title: "¡Error!",
            text: "No se pudo identificar la empresa para registrar el colaborador.",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        this.employeeData.companies_id = companyId;

        const branchIds = (this.branchOffices || []).map((item) => Number(item.id));
        if (!branchIds.length) {
          throw new Error("La empresa no tiene sedes disponibles para asignar al colaborador.");
        }

        const branchId = Number(this.employeeData.branch_office_id);
        if (!branchId || !branchIds.includes(branchId)) {
          this.employeeData.branch_office_id = branchIds[0];
        }

        if (!this.employeeData.municipality_id) {
          throw new Error("Debe seleccionar una ciudad para continuar.");
        }

        // Subir el documento
        const response = await this.uploadDocument();
        if (!response) {
          this.loading1 = false;
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido registrar!",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 2000);
          return;
        }

        // Crear el empleado
        const createEmployeeResponse = await EmployeeAPI.createEmployee(this.employeeData);

        const responseText = typeof createEmployeeResponse === "string"
          ? createEmployeeResponse
          : (createEmployeeResponse?.message || createEmployeeResponse?.data || "");

        const responseDetail =
          createEmployeeResponse?.error ||
          createEmployeeResponse?.details ||
          "";

        const responseStatus = Number(createEmployeeResponse?._status || 0);

        if (responseStatus === 422) {
          const errors = createEmployeeResponse?.errors || {};
          const messages = Object.values(errors).flat().slice(0, 8);
          Swal.fire({
            title: "Datos inválidos",
            html: messages.length
              ? "<ul style='text-align: left; padding-left: 20px;'>" +
                messages.map((m) => `<li>${m}</li>`).join("") +
                "</ul>"
              : (createEmployeeResponse?.message || "Revise los campos del formulario."),
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          this.loading1 = false;
          this.submitted = false;
          return;
        }

        const isDuplicateEmail =
          responseStatus === 409 ||
          createEmployeeResponse?.error_code === "DUPLICATE_EMAIL" ||
          (typeof responseText === "string" &&
            (responseText.includes("Este email") ||
              responseText.includes("ya se encuentra registrado")));

        if (isDuplicateEmail) {
          const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
          const emailMatch = responseText.match(emailRegex);
          const email = emailMatch ? emailMatch[0] : "correo no identificado";

          Swal.fire({
            title: "¡Error!",
            text: `El correo ${email} ya se encuentra registrado. Verifique e intente de nuevo.`,
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          this.loading1 = false;
          this.submitted = false;
          return;
        }

        const isCreated =
          createEmployeeResponse?.success === true ||
          responseStatus === 201 ||
          responseStatus === 200 ||
          (typeof responseText === "string" &&
            responseText.toLowerCase().includes("employee has been registered"));

        if (!isCreated) {
          const errorMsg = createEmployeeResponse?.message || responseText;

          if (responseStatus >= 500) {
            throw new Error(
              `Error del servidor al registrar colaborador (HTTP ${responseStatus}). ${
                errorMsg || "Sin detalle"
              }${responseDetail ? ` (${responseDetail})` : ""}`
            );
          }

          throw new Error(
            `${errorMsg || "La API no confirmó la creación del colaborador."}${
              responseDetail ? ` (${responseDetail})` : ""
            }`
              .trim()
              .replace(/\(\)$/, "")
          );
        }

        if (!createEmployeeResponse) {
          throw new Error(
              "La API no confirmó la creación del colaborador."
          );
        }

        // Si no hay error de correo duplicado, continuar con el flujo normal
        const user = JSON.parse(localStorage.getItem('user'));
        const dataScores = {
          access_token: user.token,
          companies_id: companyId,
        };

        // Calcular la clasificación de la compañía
        await newScoresAPI.classificationCompanie(dataScores);

        // Mostrar alerta de éxito
        this.loading1 = false;
        Swal.fire({
          title: "¡Éxito!",
          text: "¡Se ha registrado con éxito!",
          icon: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });

        // Redirigir después de 2 segundos
        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);

      } catch (error) {
        console.error('Error en save:', error);
        this.loading1 = false;
        this.submitted = false;

        // Manejar errores específicos
        let errorMessage = "¡Ha ocurrido un error durante el registro!";

        if (error && error.message) {
          errorMessage = error.message;
        } else if (error.response) {
          // Si el error viene de axios
          if (error.response.data && typeof error.response.data === 'string') {
            errorMessage = error.response.data;
          } else if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        Swal.fire({
          title: "¡Error!",
          text: errorMessage,
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },

    async getData() {
      try {
        const types = await IDTypeAPI.getIDTypes();
        this.idTypes = types.Identification_type || [];
        let response = await CompanyAPI.getCompany(this.$route.params.id);
        if (!response || !response.id) {
          const byUUID = await CompanyAPI.getCompanyByUUID(this.$route.params.id);
          response = byUUID && byUUID[0] ? byUUID[0] : null;
        }

        if (!response || !response.id) {
          throw new Error("No fue posible cargar la empresa asociada al registro.");
        }

        this.companyResponse = response;
        this.employeeData.companies_id = response.id || null;
        this.company_id = response.id;
        const sso = await CompanySSOAPI.getCompany(this.companyResponse.uuid);
        this.company = sso;

        const branchOffice = await BranchOfficeAPI.getNotPaginate(
          this.$route.params.id
        );
        this.branchOffices = branchOffice?.branch || [];
        if (this.branchOffices.length > 0) {
          this.employeeData.branch_office_id = Number(this.branchOffices[0].id);
        } else {
          this.employeeData.branch_office_id = null;
        }

        const eps = await EPSAPI.getAllEPS();
        if (eps) {
          this.eps = eps;
          if (this.eps.length > 0) {
            this.employeeData.eps_id = Number(this.eps[0].id);
          }
        }

        const { arl } = await ARLAPI.getAllARLs();
        if (arl) {
          const selectedArl = arl.find((item) => item.id === this.companyResponse.arl_id);
          this.arl = selectedArl ? selectedArl.name : "";
        }

        const afp = await AFPAPI.getAllAFP();
        if (afp) {
          this.afp = afp.Afp || [];
          if (this.afp.length > 0) {
            this.employeeData.afp_id = Number(this.afp[0].id);
          }
        }
        this.loading1 = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading1 = false;
      }
    },

    goBack() {
      window.location.href = `/forms/editar-empresa/${this.$store.getters["company/getCompany"].uuid}`;
    },
  },
  mounted() {
    this.getLastId();
    this.getData();
    this.moneda();
    this.getDepartment();
    this.getByMunByDeparment();
    this.getAllMunicipalitiesForEmergency();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <h4 class="header-title">Información del colaborador</h4>
                </div>

                <div class="col-6 text-right">
                  <div v-on:click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>
              </div>

              <div style="padding-top: 20px" class="row">
                <div class="col-12">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="p-2">
                          <form class="form-horizontal form-group" role="form" @submit.prevent="save">
                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Nombre completo" label-for="name">
                                  <b-form-input required type="text" id="name" maxlength="60"
                                    v-model="employeeData.full_name">
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Género" label-for="gender">
                                  <select id="gender" required class="form-control" v-model="employeeData.gender">
                                    <option value="woman">Femenino</option>
                                    <option value="man">Masculino</option>
                                    <option value="other">Otro</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Tipo de identificación" label-for="iden">
                                  <select id="iden" required class="form-control"
                                    v-model="employeeData.identification_type_id">
                                    <option v-for="item in idTypes" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Número de identificación" label-for="Nid">
                                  <b-form-input maxlength="20" required type="text" id="Nid" inputmode="numeric"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
                                    v-model="employeeData.identification_number">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Escolaridad" label-for="scolarship">
                                  <select id="scolarship" required class="form-control"
                                    v-model="employeeData.scholarship">
                                    <option value="elementary">Primaria</option>
                                    <option value="high_school">
                                      Secundaria
                                    </option>
                                    <option value="technician">
                                      Técnica y Tecnología
                                    </option>
                                    <option value="college">
                                      Universitaria
                                    </option>
                                    <option value="graduate_school">
                                      Postgrado
                                    </option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Estado civil" label-for="marital">
                                  <select id="marital" required class="form-control"
                                    v-model="employeeData.marital_status">
                                    <option value="single">Soltero(a)</option>
                                    <option value="married">Casado(a)</option>
                                    <option value="unmarried">
                                      Unión libre
                                    </option>
                                    <option value="widower">Viudo(a)</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12 pb-0 m-0">
                              <div class="form-row">
                                <b-form-group inline class="col-md-6 px-2" label="Fecha de nacimiento"
                                  label-for="birthday">
                                  <!--<h6>Edad: {{ this.anos }} años</h6>-->

                                  <b-form-input name="fecha" required v-on:change="
                                    CalcularEdad(employeeData.birthday)
                                    " type="date" id="birthday" v-model="employeeData.birthday">
                                  </b-form-input>
                                  <p id="birthday">
                                    <small>La edad del colaborador es:
                                      {{ this.anos }}
                                    </small>
                                  </p>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Tipo de contrato" label-for="contract">
                                  <select id="contract" required class="form-control"
                                    v-model="employeeData.contract_type_id">
                                    <option :value="1">Planta</option>
                                    <option :value="3">Contratista</option>
                                    <option :value="2">Aprendiz</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Personas con las que convive"
                                  label-for="gender">
                                  <select id="gender" required class="form-control"
                                    v-model="employeeData.person_with_life">
                                    <option value="0">0</option>
                                    <option value="1 o 2">1 o 2</option>
                                    <option value="3 o más">3 o más</option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Estrato socioeconómico" label-for="gender">
                                  <select id="gender" required class="form-control"
                                    v-model="employeeData.stratum_socioeconomic">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Raza" label-for="gender">
                                  <select id="gender" required class="form-control" v-model="employeeData.colorcast">
                                    <option value="Blanco">Blanco</option>
                                    <option value="Mestizo">Mestizo</option>
                                    <option value="Afrodescendiente">Afrodescendiente</option>
                                    <option value="Indígena">Indígena</option>

                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Turno de trabajo" label-for="gender">
                                  <select id="gender" required class="form-control" v-model="employeeData.workshift">
                                    <option value="Diurno">Diurno</option>
                                    <option value="Nocturno">Nocturno</option>
                                    <option value="Mixto">Mixto</option>
                                  </select>
                                </b-form-group>

                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Tipo de sangre" label-for="blood_group">
                                  <select id="blood_group" class="form-control" v-model="employeeData.blood_group">
                                    <option :value="null">-- Seleccione --</option>
                                    <option v-for="bg in bloodGroups" :key="bg" :value="bg">{{ bg }}</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12 pb-0 m-0">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Fecha de inicio"
                                  label-for="contract_start_date">
                                  <b-form-input required type="date" id="contract_start_date"
                                    v-model="employeeData.contract_start_date">
                                  </b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Fecha fin" label-for="contract_end_date">
                                  <b-form-input :required="employeeData.is_active !== 1" type="date"
                                    id="contract_end_date" required :disabled="employeeData.is_active === 1"
                                    v-model="employeeData.contract_end_date">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Modalidad de prestación de servicio"
                                  label-for="job_method">
                                  <select id="job_method" required class="form-control"
                                    v-model="employeeData.job_method">
                                    <option value="office">Presencial</option>
                                    <option value="hibrid">Teletrabajo</option>
                                    <option value="remote">
                                      Trabajo remoto
                                    </option>
                                  </select>
                                </b-form-group>

                                <b-form inline style="padding-left: 30px;
                                    padding-top: 10px;
                                    padding-bottom: 10px;
                                  ">
                                  <b-form-radio v-model="employeeData.op_admin" value="operative"
                                    class="mb-2 mr-sm-2 mb-sm-0">Operativo
                                  </b-form-radio>
                                  <b-form-radio v-model="employeeData.op_admin" value="administrative"
                                    class="mb-2 mr-sm-2 mb-sm-0">Administrativo
                                  </b-form-radio>
                                </b-form>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Empresa" label-for="company_name">
                                  <b-form-input type="text" id="company_name" v-model="company.social_reason"
                                    :disabled="true"></b-form-input>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Centro de trabajo asignado"
                                  label-for="branch_office_id">
                                  <select id="branch_ofice_id" class="form-control"
                                    v-model="employeeData.branch_office_id">
                                    <option v-for="item in branchOffices" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                  <small v-if="!loading1 && branchOffices.length === 0" class="text-danger d-block mt-1">
                                    Esta empresa no tiene centros de trabajo (sedes) configurados. Debes crear una sede para poder registrar colaboradores.
                                  </small>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Ingreso base de cotización"
                                  label-for="inputIncome">
                                  <input v-model="employeeData.contribution_base_income
                                    " maxlength="15" required
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text"
                                    class="form-control" />
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="Cargo" label-for="position">
                                  <b-form-input type="text" required id="position" v-model="employeeData.position">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Email personal" label-for="personal_email">
                                  <b-form-input type="text" required id="personal_email"
                                    v-model="employeeData.personal_email">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Email corporativo "
                                  label-for="corporate_email">
                                  <b-form-input type="text" required id="corporate_email"
                                    v-model="employeeData.corporate_email">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Clase de riesgo" label-for="risk_class">
                                  <select id="risk_class" required class="form-control"
                                    v-model="employeeData.risk_class">
                                    <option value="group_1">Clase I</option>
                                    <option value="group_2">Clase II</option>
                                    <option value="group_3">Clase III</option>
                                    <option value="group_4">Clase IV</option>
                                    <option value="group_5">Clase V</option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Estado" label-for="is_active">
                                  <select id="is_active" required class="form-control" v-model="employeeData.is_active"
                                    v-on:change="changeDate">
                                    <option :value="1">Activo</option>
                                    <option :value="0">Inactivo</option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Teléfono 1" label-for="phone1">
                                  <b-form-input maxlength="15" required
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text"
                                    id="phone_1" v-model="employeeData.phone_1">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Teléfono 2" label-for="phone2">
                                  <b-form-input maxlength="15"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text"
                                    id="phone_2" v-model="employeeData.phone_2">
                                  </b-form-input>

                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Departamento" label-for="department_id">
                                  <select id="department_id" required class="form-control" v-model="department_id"
                                    @change="getByMunByDeparment()">
                                    <b-form-select-option v-for="item in department" :key="item.id" :value="item.id">
                                      {{ item.name }}
                                    </b-form-select-option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Ciudad" label-for="municipality_id">
                                  <select class="form-control" v-model="employeeData.municipality_id">
                                    <b-form-select-option v-for="item in municipality" :key="item.id" :value="item.id">
                                      {{ item.name }}
                                    </b-form-select-option>
                                  </select>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Barrio" label-for="neighborhood">
                                  <b-form-input type="text" required id="neighborhood"
                                    v-model="employeeData.neighborhood">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Dirección" label-for="address">
                                  <b-form-input type="text" required id="address" v-model="employeeData.address">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Zona" label-for="neighborhood_type">
                                  <select id="neighborhood_type" required class="form-control"
                                    v-model="employeeData.neighborhood_type">
                                    <option value="urban">Urbana</option>
                                    <option value="rural">Rural</option>
                                  </select>
                                </b-form-group>

                                <b-form-group class="col-md-6 px-2" label="EPS" label-for="eps_id">
                                  <select id="eps_id" required class="form-control" v-model="employeeData.eps_id">
                                    <option v-for="item in eps" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="AFP" label-for="afp_id">
                                  <select id="afp_id" required class="form-control" v-model="employeeData.afp_id">
                                    <option v-for="item in afp" :value="item.id" :key="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" :label="`ARL: ${arl || ''}`" label-for="file">
                                  <b-form-file type="file" id="file" required ref="file" name="file"
                                    browse-text="Buscar" inline :placeholder="`Selecciona un archivo...`"
                                    drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile"
                                    v-on:change="uploadFile"
                                    accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                  </b-form-file>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12 mt-3">
                              <h5 class="header-title">Contacto de emergencia</h5>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Nombre contacto de emergencia"
                                  label-for="emergency_contact_name">
                                  <b-form-input maxlength="100" type="text" id="emergency_contact_name"
                                    v-model="employeeData.emergency_contact_name">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Parentesco"
                                  label-for="emergency_contact_relationship">
                                  <b-form-input maxlength="50" type="text" id="emergency_contact_relationship"
                                    v-model="employeeData.emergency_contact_relationship">
                                  </b-form-input>
                                </b-form-group>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-row">
                                <b-form-group class="col-md-6 px-2" label="Teléfono contacto de emergencia"
                                  label-for="emergency_contact_phone">
                                  <b-form-input maxlength="20"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text"
                                    id="emergency_contact_phone" v-model="employeeData.emergency_contact_phone">
                                  </b-form-input>
                                </b-form-group>
                                <b-form-group class="col-md-6 px-2" label="Ciudad de residencia (contacto de emergencia)"
                                  label-for="emergency_contact_municipality_id">
                                  <div class="position-relative">
                                    <input id="emergency_contact_municipality_id" type="text" class="form-control"
                                      autocomplete="off" placeholder="Escribe para buscar ciudad..."
                                      :value="emergencyMunicipalitySearch" @input="onEmergencyMunicipalitySearch"
                                      @focus="emergencyMunicipalityOpen = true"
                                      @blur="closeEmergencyMunicipalityDropdown" />
                                    <ul v-if="emergencyMunicipalityOpen"
                                      class="list-group position-absolute w-100 shadow-sm"
                                      style="max-height: 220px; overflow-y: auto; z-index: 1050;">
                                      <li v-if="filteredEmergencyMunicipalities.length === 0"
                                        class="list-group-item text-muted">
                                        Sin resultados
                                      </li>
                                      <li v-for="item in filteredEmergencyMunicipalities" :key="item.id"
                                        class="list-group-item list-group-item-action"
                                        style="cursor: pointer;"
                                        @mousedown.prevent="selectEmergencyMunicipality(item)">
                                        {{ item.name }}
                                      </li>
                                    </ul>
                                  </div>
                                </b-form-group>
                              </div>
                            </div>

                            <!--button-->
                            <div class="form-group text-right m-b-0">
                              <button :disabled="submitted || branchOffices.length === 0" type="submit" class="btn btn-primary">
                                Guardar
                              </button>
                              <button type="reset" class="btn btn-secondary m-l-5 ml-1" v-on:click="goBack">
                                Cancelar
                              </button>
                            </div>
                            <b-toast :visible="showNotification">
                              <div slot="toast-title">
                                <strong class="mr-auto">
                                  Registro exitoso
                                </strong>
                              </div>
                              <div>
                                El colaborador
                                {{ employeeData.full_name }}
                                ha sido registrado con éxito.
                              </div>
                            </b-toast>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- end row -->
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- end row -->
  </Layout>
</template>
